import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GetCareNowFormatService } from '../../../utilities/getcarenow-format.service';
import { environment } from '../../../../../environments/environment';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-in-person-urgent-care-option-card',
  imports: [CommonModule, TranslateModule, MatCardModule, MatButtonModule],
  templateUrl: './in-person-urgent-care-option-card.component.html',
  styleUrl: './in-person-urgent-care-option-card.component.css'
})
export class InPersonUrgentCareOptionCardComponent {
  @Input() providerId!: string;
    @Input() departmentId!: string;
    @Input() name!: string;
    @Input() photo!: string;
    @Input() waitTime!: number;
    @Input() nextAvailability!: string;
    @Input() isOpen: boolean = false;
    @Input() address: string | null = null;
    @Input() distance!: number;
    @Input() imageUrl!: string;
    @Input() locale: string | null = null;
    
  
    private getCareNowFormatService: GetCareNowFormatService;
      
    public soonAsText: string = 'TITLE';
    public virtualVisitText: string = 'DESCRIPTION';
    public reserveText: string = 'RESERVE';
    public walkinText: string = 'WALKIN';
    public vucText: string = '247VUC';
    public milesAwayText: string = 'MILES_AWAY';
    public today: string = 'TODAY';
    public tomorrow : string = 'TOMORROW';
    public openTomorrow: string = 'OPEN_TOMORROW';  
    public waitTimeStr: string = '';
  
    constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
      this.translate.use(sessionStorage.getItem("locale") || 'en-US'); // Default to 'en-US' if no locale is provided
      this.getCareNowFormatService = new GetCareNowFormatService(this.translate);
    }

    ngOnInit(): void {
    
      this.waitTimeStr = this.getCareNowFormatService.formatWaitTime(this.waitTime);
    
      this.translate.get('WALK_IN_WAIT').subscribe((translated: string) => {
        this.soonAsText = translated;
      });
    
      this.translate.get('MILES_AWAY').subscribe((translated: string) => {
        this.milesAwayText = translated;
      });
    
      this.translate.get('RESERVE').subscribe((translated: string) => {
        this.reserveText = translated;
      });
      
      this.translate.get('OPEN_TOMORROW').subscribe((translated: string) => {
        this.openTomorrow = translated;
      });

      this.translate.get('WALKIN').subscribe((translated: string) => {
        this.walkinText = translated;
      });

      this.translate.get('247VUC').subscribe((translated: string) => {
        this.vucText = translated;
      });
    }

    reserveNow () {
      const eptID = sessionStorage.getItem("eptID");

      if (eptID == null || eptID == undefined || eptID == "") {
        this.reserveNowUnAuth();
      }
      else {
        this.reserveNowAuth();
      }
    }

    reserveNowUnAuth() {
      var deepLink = environment.web_unauth_omw_deep_link_base_url + this.departmentId;
      deepLink += "&linksource=PLUAIPUC";

      this.monitoringService.logEvent('Schedule/NoAuth', { feature: 'get-care-now', subfeature: 'IPUC', platform: 'web' }); // log as web event
      
      console.log("reserve now clicked (IPUC)");
      console.log(deepLink);

      window.location.href = deepLink;
    }
    
    reserveNowAuth() {
      var deepLink = environment.web_omw_deep_link_base_url + this.departmentId; // For web users, use the web deep link
      deepLink += "?linksource=AUTHIPUCSCHED";
      
      console.log("reserve now clicked (IPUC)");
      console.log(deepLink);
    
      this.monitoringService.logEvent('Schedule', { feature: 'get-care-now', subfeature: 'IPUC', platform: 'web' }); // log as web event
      window.location.href = deepLink;
    }

    walkinNow() {
      var deepLink = environment.web_google_map + encodeURIComponent(this.address || ''); 
      this.monitoringService.logEvent('WalkinNow', { feature: 'get-care-now', subfeature: 'IPUC', platform: 'web' }); // log as web event  
      window.location.href = deepLink;
    }

    vucNow() {
      const eptID = sessionStorage.getItem("eptID");

      if (eptID == null || eptID == undefined || eptID == "") {
        this.vucNowUnAuth();
      }
      else {
        this.vucNow();
      }

    }

    vucNowUnAuth() {
      // web deep link for unauthenticated users to generic VUC provider with both peds and adult visit types
      // https://mymemorialcaretst19.memorialcare.org/MyChartTST/openscheduling/standalone?id=7000892&vt=52216,52220
      
      var deepLink = environment.web_open_scheduling_deep_link_base_url
        + "/standalone?id=" + environment.generic_vuc_provider_id
        + "&vt=" + environment.pediatric_vuc_rfv_id + "," + environment.adult_vuc_rfv_id;

      this.monitoringService.logEvent('VUCNow/NoAuth', { feature: 'get-care-now', subfeature: 'IPUC', platform: 'web' }); // log as web event

      console.log("VUC Now clicked (IPUC)");
      console.log(deepLink);
      window.location.href = deepLink;
    }

    vucNowAuth() {
      var deepLink = environment.web_vuc_deep_link_base_url; 
  
      const age = sessionStorage.getItem("age");
      var ageNumber = age ? parseInt(age) : null;
  
      if (ageNumber != null) {
          deepLink += ageNumber < 18 
            ? environment.pediatric_vuc_prc_id
            : environment.adult_vuc_prc_id;
      } 

      this.monitoringService.logEvent('VUCNow', { feature: 'get-care-now', subfeature: 'IPUC', platform: 'web' }); // log as web event
      window.location.href = deepLink;
    }
}
